import { Step, WearableModalType } from "./types"

export const STEPS_CONFIG: Partial<Record<WearableModalType, Step[]>> = {
   [WearableModalType.SCAN]: [
      { label: "Step 1:", description: "Secure ReassureBand onto inmate." },
      {
         label: "Step 2:",
         description:
            "Scan ReassureBand, this ReassureBand will be assigned to inmate.",
      },
   ],
   [WearableModalType.MANUAL_ASSIGN]: [
      {
         label: "Step 1:",
         description: "Select a ReassureBand from the dropdown list.",
      },
      {
         label: "Step 2:",
         description: "Click Save to assign the ReassureBand to the inmate.",
      },
   ],
   [WearableModalType.MANUAL_SWAP]: [
      {
         label: "Step 1:",
         description: "Remove current ReassureBand from inmate.",
      },
      {
         label: "Step 2:",
         description: "Secure the new ReassureBand on inmate.",
      },
      {
         label: "Step 3:",
         description:
            "Find the new ReassureBand in the list, select and save it.",
      },
   ],
   [WearableModalType.OPTIONS]: [
      {
         label: "Step 1:",
         description: "Remove current ReassureBand from inmate.",
      },
      {
         label: "Step 2:",
         description: "Secure the new ReassureBand on inmate.",
      },
      {
         label: "Step 3:",
         description:
            "Scan the new ReassureBand worn by the inmate to complete the process.",
      },
   ],
}
